// extracted by mini-css-extract-plugin
module.exports = {"Main":"OffSiteDeliveryItem_Main__2dXLF"};